export default {
	1: 'Crystals',
	2: 'Keys',
	3: 'Coins'
}
